import React from "react";
import { DialogTitle, DialogContent } from "@mui/material";
import CustomDialog from "../../common/components/CustomDialog";
import ReferralCreateForm from "./ReferralCreateForm";

const ReferralCreateDialog = ({ open, onClose, referralUuid = null, fromReceived = false }) => {
  return (
    <CustomDialog open={open} onClose={onClose}>
      <DialogTitle>
        {referralUuid ? "Edit Referral or Order" : "Add New Referral or Order"}
      </DialogTitle>
      <DialogContent>
        <ReferralCreateForm onClose={onClose} referralUuid={referralUuid} fromReceived={fromReceived} />
      </DialogContent>
    </CustomDialog>
  );
};

export default ReferralCreateDialog;
